import generateTypes from '../../utils/generateTypes';

export const GET_ADMIN_USERS = generateTypes('GET_ADMIN_USERS');
export const RESET_ADMIN_USERS = generateTypes('RESET_ADMIN_USERS');
